var _g, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyDashboardPortfolio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 88,
    viewBox: "0 0 102 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3645:1782)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.189209,
    width: 101.622,
    height: 80,
    rx: 6,
    fill: "#EBBBA6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.189209 6C0.189209 2.68629 2.8755 0 6.18921 0H95.8108C99.1245 0 101.811 2.68629 101.811 6V12.973H0.189209V6Z",
    fill: "#DB6443"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.8648,
    cy: 6.48638,
    r: 2.16216,
    fill: "#E6BAA8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5137,
    cy: 6.48638,
    r: 2.16216,
    fill: "#E6BAA8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.1622,
    cy: 6.48638,
    r: 2.16216,
    fill: "#E6BAA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6643 37.8007C90.6643 36.6271 89.713 35.6758 88.5394 35.6758C87.3659 35.6758 86.4145 36.6271 86.4145 37.8007V69.1893H90.6643V37.8007Z",
    fill: "#DB6443"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2485 47.5331C72.2485 46.3595 71.2972 45.4082 70.1237 45.4082C68.9501 45.4082 67.9988 46.3595 67.9988 47.5331V69.192H72.2485V47.5331Z",
    fill: "#DB6443"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8333 58.3417C53.8333 57.1681 52.8819 56.2168 51.7084 56.2168C50.5348 56.2168 49.5835 57.1681 49.5835 58.3417V69.1898H53.8333V58.3417Z",
    fill: "#DB6443"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4175 55.0975C35.4175 53.924 34.4661 52.9727 33.2926 52.9727C32.1191 52.9727 31.1677 53.924 31.1677 55.0975V69.1889H35.4175V55.0975Z",
    fill: "#DB6443"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0017 63.7479C17.0017 62.5744 16.0504 61.623 14.8768 61.623C13.7033 61.623 12.7519 62.5744 12.7519 63.7479V69.1906H17.0017V63.7479Z",
    fill: "#DB6443"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3645:1782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91895 68.1082C12.4315 64.2472 20.6226 56.5252 33.2862 56.5252C49.1156 56.5252 70.9752 65.2125 92.0811 35.6758",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.989 17.9672C87.2764 16.5409 91.1108 17.4419 93.4187 20.1832C95.727 22.9245 95.9614 26.8561 93.9955 29.8524C92.0296 32.8487 88.3299 34.199 84.896 33.1732C81.4619 32.1478 79.1088 28.9898 79.1082 25.406C79.1082 25.1678 79.1183 24.9328 79.139 24.7004C79.3978 21.7364 81.2592 19.152 83.989 17.9672Z",
    fill: "white",
    stroke: "#DB6443",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9358 21.4902V22.4093",
    stroke: "#DB6443",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9492 29.123V30.069",
    stroke: "#DB6443",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0497 25.7792C85.8952 25.7021 85.0321 24.9071 85.0681 23.9924C85.104 23.0777 86.0828 22.3989 87.2373 22.476C88.3918 22.5531 89.2549 23.3481 89.219 24.2628",
    stroke: "#DB6443",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0485 25.7784C88.203 25.8554 89.0661 26.6505 89.0302 27.5652C88.9942 28.4798 88.0154 29.1587 86.8609 29.0816C85.7064 29.0045 84.8433 28.2094 84.8793 27.2948",
    stroke: "#DB6443",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.0813,
    y: 23.7832,
    width: 24.8649,
    height: 2.16216,
    rx: 1.08108,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0813,
    y: 31.3516,
    width: 33.5135,
    height: 2.16216,
    rx: 1.08108,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0813,
    y: 38.916,
    width: 24.8649,
    height: 2.16216,
    rx: 1.08108,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3645:1782",
    x: 0.189209,
    y: 0,
    width: 101.622,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3645:1782"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.392157 0 0 0 0 0.262745 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3645:1782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3645:1782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3645:1782",
    x: 6.91895,
    y: 34.6758,
    width: 88.1624,
    height: 40.4316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.392157 0 0 0 0 0.262745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3645:1782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3645:1782",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDashboardPortfolio);
export default __webpack_public_path__ + "static/media/empty-dashboard-portfolio.0c865c7d.svg";
export { ForwardRef as ReactComponent };